import {Typography} from '@pixel-party/Typography/v2';
import type {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';

interface SuccessMessageProps {
  customMessage?: ReactNode;
}

export function SuccessMessage({customMessage}: SuccessMessageProps) {
  const {t} = useTranslation();

  return (
    <Typography use="body2">
      {customMessage || t('forms.shared.successMessage')}
    </Typography>
  );
}
